// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNWANTED VARIABLE
// MODFIED DATA : 10-09-2025
import RequestReportActionTypes from './request-report.types';

/** ***************** FETCH REQUEST REPORT DETAILS START *********************** */
export const fetchRequestReportDetailsStart = (fetchData: any) => ({
	type: RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_START,
	payload: fetchData,
});

export const fetchRequestReportDetailsSuccess = (successData: any) => ({
	type: RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchRequestReportDetailsFailure = (failureData: any) => ({
	type: RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchRequestReportDetailsResponseResetStart = () => ({
	type: RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_RESPONSE_RESET,
});

export const fetchRequestReportDetailsResponseChanged = () => ({
	type: RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH REQUEST REPORT DETAILS END *********************** */

/** ***************** ADD REQUEST REPORT DETAILS START *********************** */
export const addRequestReportDetailsStart = (fetchData: any) => ({
	type: RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_START,
	payload: fetchData,
});

export const addRequestReportDetailsSuccess = (successData: any) => ({
	type: RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_SUCCESS,
	payload: successData,
});

export const addRequestReportDetailsFailure = (failureData: any) => ({
	type: RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_FAILURE,
	payload: failureData,
});

export const addRequestReportDetailsResponseResetStart = () => ({
	type: RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_RESPONSE_RESET,
});

export const addRequestReportDetailsResponseChanged = () => ({
	type: RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD REQUEST REPORT DETAILS END *********************** */

/** ***************** DELETE REQUEST REPORT DETAILS START *********************** */
export const deleteRequestReportStart = (data: any) => ({
	type: RequestReportActionTypes.DELETE_REQUEST_REPORT_START,
	payload: data,
});

export const deleteRequestReportSuccess = (successData: any) => ({
	type: RequestReportActionTypes.DELETE_REQUEST_REPORT_SUCCESS,
	payload: successData,
});

export const deleteRequestReportFailure = (failureData: any) => ({
	type: RequestReportActionTypes.DELETE_REQUEST_REPORT_FAILURE,
	payload: failureData,
});

export const deleteRequestReportReset = () => ({
	type: RequestReportActionTypes.DELETE_REQUEST_REPORT_RESET,
});

export const deleteRequestReportChanged = () => ({
	type: RequestReportActionTypes.DELETE_REQUEST_REPORT_CHANGED,
});
/** ***************** DELETE REQUEST REPORT DETAILS END *********************** */
